import styled from '@emotion/styled';

export const DraggableListItemContainer = styled.div`
    display: flex;
    align-items: center;
`;
